/* Currency selection jumping from the header to the menu */
document.addEventListener('DOMContentLoaded', ev => {

  let localizationForm = document.querySelector("#localization_form");
  let mobileLocalizationContainer = document.querySelector("#mobile-localization-container");
  let desktopLocalizationContainer = document.querySelector("#desktop-localization-container");

  function moveCurrencyAndLanguageSelector() {
    if ( window.innerWidth <= 768 ) {
      mobileLocalizationContainer.appendChild(localizationForm);
    } else if ( window.innerWidth > 768 ){
      desktopLocalizationContainer.appendChild(localizationForm);
    }
  }

  window.addEventListener('resize', function () {
    moveCurrencyAndLanguageSelector();
  })

  setTimeout(function () {
	moveCurrencyAndLanguageSelector();
  }, 2000);
})


/*Remove Z size from Popup*/
jQuery(document).ready(function () {
    let optionRemove = false;
    jQuery('body').on('click', '.product-single__form .back-stock-btn', function () {
        if (!optionRemove) {
            jQuery('#BIS_frame').contents().find('#variants option:first-child').remove();
            optionRemove = true;
        }
    });
});